import { errorLogService } from "../services/errorLogService";

class Logger {
  constructor() {
    this.isDevelopment = process.env.NODE_ENV === "development";
    this.isTest = process.env.NODE_ENV === "test";
    this.debugEnabled = process.env.REACT_APP_DEBUG === "true";

    this.log = this.log.bind(this);
    this.error = this.error.bind(this);
    this.critical = this.critical.bind(this);
    this.warn = this.warn.bind(this);
    this.info = this.info.bind(this);
    this.debug = this.debug.bind(this);
    this.auth = this.auth.bind(this);
    this.family = this.family.bind(this);
    this.order = this.order.bind(this);
    this.menu = this.menu.bind(this);
    this.api = this.api.bind(this);
    this.performance = this.performance.bind(this);
    this.group = this.group.bind(this);
    this.table = this.table.bind(this);
    this.trace = this.trace.bind(this);
  }

  log(message, ...args) {
    if (this.debugEnabled || this.isTest) {
      console.log(`🔍 ${message}`, ...args);
    }
  }

  /**
   * Локальное логирование ошибки + возможность отправить в БД
   */
  error(message, error, context = {}) {
    console.error(`❌ ${message}`, error, context);

    // В продакшене отправляем критические ошибки в БД
    if (!this.isDevelopment) {
      errorLogService.logError({ message, error, context, severity: "error" });
    }
  }

  /**
   * Критическая ошибка, всегда уходит в БД
   */
  critical(message, error, context = {}) {
    console.error(`🚨 CRITICAL: ${message}`, error, context);
    errorLogService.logError({ message, error, context, severity: "critical" });
  }

  warn(message, ...args) {
    if (this.debugEnabled || this.isDevelopment || this.isTest) {
      console.warn(`⚠️ ${message}`, ...args);
    }
  }

  info(message, ...args) {
    if (this.debugEnabled || this.isDevelopment || this.isTest) {
      console.info(`ℹ️ ${message}`, ...args);
    }
  }

  debug(message, ...args) {
    if (this.debugEnabled) {
      console.debug(`🐛 ${message}`, ...args);
    }
  }

  // Специализированные логи для разных контекстов
  auth(message, ...args) {
    this.log(`🔐 ${message}`, ...args);
  }

  family(message, ...args) {
    this.log(`👨‍👩‍👧‍👦 ${message}`, ...args);
  }

  order(message, ...args) {
    this.log(`📋 ${message}`, ...args);
  }

  menu(message, ...args) {
    this.log(`🍽️ ${message}`, ...args);
  }

  api(message, ...args) {
    this.log(`🌐 ${message}`, ...args);
  }

  performance(message, ...args) {
    if (this.isDevelopment) {
      const start = performance.now();
      return () => {
        const end = performance.now();
        console.log(`⚡ ${message}: ${(end - start).toFixed(2)}ms`, ...args);
      };
    }
    return () => {};
  }

  // Группировка логов
  group(label, callback) {
    if (this.isDevelopment || this.isTest) {
      console.group(label);
      callback();
      console.groupEnd();
    } else {
      callback();
    }
  }

  // Таблица для структурированных данных
  table(data, columns) {
    if (this.isDevelopment || this.isTest) {
      if (columns) {
        console.table(data, columns);
      } else {
        console.table(data);
      }
    }
  }

  // Логирование с трассировкой стека
  trace(message, ...args) {
    if (this.isDevelopment || this.isTest) {
      console.trace(`📍 ${message}`, ...args);
    }
  }
}

// Создаем единственный экземпляр
const logger = new Logger();

export default logger;
